<template>
    <v-container fluid>
        <v-card class="mb-3">
            <v-card-title class="title">
                Import data
            </v-card-title>
            <v-card-text>
                <v-layout>
                    <div class="mr-3">Import from</div>
                    <v-radio-group v-model="importType" row class="mt-0">
                        <v-radio
                            label="File"
                            value="file"
                        ></v-radio>
                        <v-radio
                            label="Link"
                            value="link"
                        ></v-radio>
                    </v-radio-group>
                </v-layout>
                <div v-if="importType === 'file'">
                    <v-text-field
                        label="Selected File"
                        @click="pickFile"
                        v-model="fileName"
                        prepend-icon="attach_file"
                    ></v-text-field>
                    <input
                        type="file"
                        style="display: none"
                        ref="image"
                        accept="csv"
                        @change="onFilePicked"
                    >
                </div>
                <div v-if="importType === 'link'">
                    <v-text-field label="Link"></v-text-field>
                </div>
            </v-card-text>
        </v-card>
        <SimpleDataTable
            :headers="headers"
            :items="dataTable"
            class="table-in-tab"
        ></SimpleDataTable>
        <div>
            <v-btn color="primary" class="mx-0 my-3" to="/campaign/new">Start new campaign using this data</v-btn>
        </div>
    </v-container>
</template>
<script>
import SimpleDataTable from '@/components/SimpleDataTable'

export default {
    name      : 'ImportCustomerData',
    components: {SimpleDataTable},
    data() {
        let dataTable = []
        for (let i = 0; i < 100; i++) {
            dataTable.push({
                name    : 'Nguyễn Trung Dũng ' + i,
                email   : 'DungNT12' + i + '@sendo.com',
                phone   : '0912345678',
                schedule: (Math.floor(Math.random() * 12)) + ':30 pm '
            })
        }
        return {
            dataTable : dataTable,
            fileName  : '',
            importType: 'file'
        }
    },
    computed  : {
        headers() {
            return [
                {
                    text    : this.$filters.capitalize(this.$t('name')),
                    value   : 'name',
                    sortable: false
                },
                {
                    text    : this.$filters.capitalize(this.$t('email')),
                    value   : 'email',
                    sortable: false
                },
                {
                    text    : this.$filters.capitalize(this.$t('phone')),
                    value   : 'phone',
                    sortable: false
                },
                {
                    text    : this.$filters.capitalize(this.$t('schedule')),
                    value   : 'schedule',
                    sortable: false
                }
            ]
        }
    },
    mounted() {
        this.$appService.hideLoading()
    },
    methods   : {
        onFilePicked() {

        },
        pickFile() {
            this.$refs.image.click()
        }
    }
}
</script>
